import React from 'react';
import Modal from './Modal';
import Button from './Button';

export default function ConfirmDialog({
  isOpen,
  title,
  description,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  onConfirm,
  onCancel
}) {
  return (
    <Modal isOpen={isOpen} onClose={onCancel}>
      <div className="p-6">
        <h3 className="sp-value" style={{ fontSize: '16px', fontWeight: 600 }}>{title}</h3>
        <p className="text-sm sp-muted mt-2">{description}</p>
        <div className="flex items-center justify-end gap-2 mt-6">
          <Button variant="secondary" size="sm" onClick={onCancel} type="button">
            {cancelLabel}
          </Button>
          <Button variant="danger" size="sm" onClick={onConfirm} type="button">
            {confirmLabel}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
